<template>
  <v-bottom-sheet style="z-index: 999999" v-model="show" persistent hide-overlay inset max-width="800" content-class="black-week-sheet-container">
    <v-sheet class="premium-sheet" dark>
      <div class="glow-effect"></div>

      <v-btn icon class="close-btn" @click="close">
        <v-icon color="grey lighten-1">mdi-close</v-icon>
      </v-btn>

      <div class="content-wrapper pa-5 pt-10">
        <template v-if="!isLive">
          <div class="text-center my-10">
            <h3 class="text-h4 font-weight-black mb-4">SOON...</h3>
            <v-btn large outlined @click="close">Schliessen</v-btn>
          </div>
        </template>

        <template v-else>
          <div v-if="currentView === 'menu'" key="menu-view" class="view-transition">
            <div class="text-center mb-6 position-relative">
              <v-chip outlined color="#00963f" class="mb-3 font-weight-bold px-4" small style="border-width: 1px; background: rgba(0, 150, 63, 0.1)">
                <span class="pulse-dot mr-2"></span> JETZT LIVE
              </v-chip>
              <h2 class="main-title white--text font-weight-black italic text-uppercase mb-1">BLACK WEEK</h2>
              <p class="subtitle-text grey--text text--lighten-1 mb-0">Wähle deinen Vorteil</p>
            </div>

            <div class="cards-container mb-4">
              <v-card class="promo-card mb-4 elevation-10" @click="showContractDialog = true" v-ripple>
                <div class="card-badge">-20% RABATT</div>
                <div class="d-flex align-center pa-4 flex-nowrap">
                  <div class="icon-box mr-4 elevation-5">
                    <v-icon size="28" color="white">mdi-diamond-stone</v-icon>
                  </div>
                  <div class="flex-grow-1 py-1 overflow-hidden">
                    <div class="card-title text-truncate">Abo aufwerten</div>
                    <div class="card-desc">Ergänze Zusatzpakete zum Sparpreis.</div>
                  </div>
                  <v-icon color="#00963f" class="ml-2">mdi-chevron-right</v-icon>
                </div>
              </v-card>

              <v-card class="promo-card elevation-10" @click="currentView = 'offers'" v-ripple>
                <div class="card-badge grey-badge">TOP DEAL</div>
                <div class="d-flex align-center pa-4 flex-nowrap">
                  <div class="icon-box secondary-icon-box mr-4 elevation-5">
                    <v-icon size="28" color="white">mdi-calendar-check</v-icon>
                  </div>
                  <div class="flex-grow-1 py-1 overflow-hidden">
                    <div class="card-title text-truncate">Laufzeit verlängern</div>
                    <div class="card-desc">Jahres-Deals sichern & bis CHF 1'000.- sparen.</div>
                  </div>
                  <v-icon color="grey lighten-1" class="ml-2">mdi-chevron-right</v-icon>
                </div>
              </v-card>
            </div>

            <div class="text-center mt-6 mb-2">
              <div class="caption grey--text text--darken-1 mb-4 font-italic" style="font-size: 0.7rem">
                Aktion gültig bis 7.12. • Nicht kumulierbar
              </div>
              <v-btn text small color="grey darken-1" @click="close"> Schliessen </v-btn>
            </div>
          </div>

          <div v-else key="offers-view" class="view-transition">
            <div class="d-flex align-center mb-4">
              <v-btn icon small @click="currentView = 'menu'" class="mr-2">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <h3 class="text-h6 font-weight-bold mb-0">Wähle deine Mitgliedschaft</h3>
            </div>

            <div class="d-flex justify-center mb-6">
              <v-btn-toggle v-model="selectedLocation" mandatory rounded class="location-toggle">
                <v-btn value="wellcome" active-class="active-toggle" small> WELL COME FIT </v-btn>
                <v-btn value="winti" active-class="active-toggle" small> WINTI FIT </v-btn>
              </v-btn-toggle>
            </div>

            <v-alert border="left" colored-border color="orange accent-3" elevation="2" class="mb-6 rounded-lg" icon="mdi-store-alert">
              <div class="subtitle-2 font-weight-bold orange--text text--accent-3">Nur im Studio einlösbar</div>
              <div class="caption grey--text text--lighten-2" style="line-height: 1.2">
                Als bestehendes Mitglied kannst du deinen Vertrag zu diesen Konditionen <strong>nur direkt vor Ort</strong> verlängern.
              </div>
            </v-alert>

            <div class="pricing-scroll-container pb-4">
              <div class="d-flex">
                <v-card
                  v-for="(plan, index) in currentPrices"
                  :key="index"
                  class="pricing-card mr-3 d-flex flex-column justify-space-between"
                  :class="{ 'popular-card': plan.popular }"
                  width="160"
                  min-width="160">
                  <div v-if="plan.popular" class="popular-badge">POPULAR</div>

                  <div class="text-center pt-4 px-2">
                    <div class="caption grey--text text--lighten-1 text-uppercase font-weight-bold mb-2">
                      {{ plan.years }} Jahr{{ plan.years > 1 ? "e" : "" }}
                    </div>

                    <div class="text-decoration-line-through grey--text caption mb-0">{{ plan.oldPrice }}</div>
                    <div class="text-h5 font-weight-black white--text mb-2">{{ plan.price }}</div>

                    <v-chip x-small color="rgba(0, 150, 63, 0.2)" text-color="#00963f" class="font-weight-bold">
                      {{ plan.discount }} auf Pakete
                    </v-chip>
                  </div>

                  <div class="pa-3 mt-2">
                    <v-btn
                      block
                      small
                      depressed
                      :color="plan.popular ? '#00963f' : 'transparent'"
                      :class="plan.popular ? 'black--text' : 'white--text outlined-btn'"
                      class="font-weight-bold"
                      disabled>
                      Nur im Studio
                    </v-btn>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
        </template>
      </div>
    </v-sheet>

    <upgrade-contract
      v-if="showContractDialog"
      :useCustomer="true"
      @hide="showContractDialog = false"
      @created="upgradeCreated"
      :dialog="showContractDialog">
    </upgrade-contract>
  </v-bottom-sheet>
</template>

<script>
import VueCountdown from "@chenfengyuan/vue-countdown"
import upgradeContract from "@/views/dashboard/contract/components/upgradeContract.vue"
import userService from "@/services/userService"
import moment from "moment"

export default {
  name: "BlackWeekTeaser",
  components: { VueCountdown, upgradeContract },
  data() {
    return {
      userService,
      show: false,
      showContractDialog: false,
      targetDate: "2025-11-19T00:00:00",
      forceLive: false,

      // Variables
      currentView: "menu",
      selectedLocation: "wellcome",

      pricingData: {
        wellcome: [
          { years: 1, oldPrice: "789.-", price: "690.-", discount: "20%", popular: false },
          { years: 2, oldPrice: "1'479.-", price: "1'199.-", discount: "30%", popular: true },
          { years: 3, oldPrice: "2'469.-", price: "1'599.-", discount: "40%", popular: false },
          { years: 4, oldPrice: "2'859.-", price: "1'999.-", discount: "50%", popular: false },
        ],
        winti: [
          { years: 1, oldPrice: "980.-", price: "890.-", discount: "20%", popular: false },
          { years: 2, oldPrice: "1'960.-", price: "1'579.-", discount: "30%", popular: true },
          { years: 3, oldPrice: "2'940.-", price: "2'199.-", discount: "40%", popular: false },
          { years: 4, oldPrice: "3'920.-", price: "2'749.-", discount: "50%", popular: false },
        ],
      },
    }
  },
  computed: {
    timeUntilStart() {
      const now = new Date().getTime()
      const target = new Date(this.targetDate).getTime()
      const diff = target - now
      return diff > 0 ? diff : 0
    },
    isLive() {
      return this.timeUntilStart <= 0 || this.forceLive
    },
    currentPrices() {
      return this.pricingData[this.selectedLocation]
    },
  },
  mounted() {
    this.checkVisibility()
  },
  methods: {
    upgradeCreated() {
      if (this.$toast) this.$toast.success("Upgrade erfolgreich erstellt!")
      this.close()
    },
    checkVisibility() {
      // Session Storage Check statt LocalStorage
      const hasSeenSession = sessionStorage.getItem("bw_teaser_seen_session")
      const isBeforeEnd = moment().isBefore("2025-11-29")

      // Nur anzeigen, wenn in dieser Session noch nicht gesehen UND Datum gültig
      if (!hasSeenSession && isBeforeEnd) {
        setTimeout(() => {
          this.show = true
        }, 2000)
      }
    },
    handleCountdownEnd() {
      this.forceLive = true
    },
    close() {
      this.show = false
      setTimeout(() => {
        this.currentView = "menu"
      }, 300)

      // Setze Flag im Session Storage
      sessionStorage.setItem("bw_teaser_seen_session", "true")
    },
  },
}
</script>

<style lang="scss" scoped>
$wcf-green: #00963f;

.premium-sheet {
  background: linear-gradient(to bottom, #050505, #121212);
  border-top-left-radius: 32px !important;
  border-top-right-radius: 32px !important;
  position: relative;
  overflow: hidden;
  min-height: 50vh;
}

.glow-effect {
  position: absolute;
  top: -120px;
  left: 50%;
  transform: translateX(-50%);
  width: 150%;
  height: 300px;
  background: radial-gradient(circle, rgba($wcf-green, 0.12) 0%, rgba(0, 0, 0, 0) 70%);
  pointer-events: none;
  z-index: 0;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.05);
}

.main-title {
  font-size: 2.2rem !important;
  line-height: 1;
  letter-spacing: -1px;
  text-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  position: relative;
  z-index: 1;
}

.subtitle-text {
  font-size: 1rem;
  font-weight: 300;
}

.pulse-dot {
  width: 6px;
  height: 6px;
  background-color: $wcf-green;
  border-radius: 50%;
  display: inline-block;
  box-shadow: 0 0 8px $wcf-green;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* --- MAIN MENU CARD STYLES --- */
.promo-card {
  background-color: rgba(30, 30, 30, 0.6) !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 20px !important;
  position: relative;
  overflow: visible;
  backdrop-filter: blur(10px);
  transition: transform 0.2s;

  &:active {
    transform: scale(0.98);
    background-color: rgba(40, 40, 40, 0.8) !important;
  }
}

.icon-box {
  width: 48px;
  height: 48px;
  min-width: 48px;
  min-height: 48px;
  flex-shrink: 0;
  border-radius: 14px;
  background: linear-gradient(135deg, $wcf-green 0%, darken($wcf-green, 15%) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.secondary-icon-box {
  background: linear-gradient(135deg, #424242 0%, #212121 100%);
}

.card-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: $wcf-green;
  color: white;
  font-size: 0.65rem;
  font-weight: 900;
  padding: 4px 10px;
  border-bottom-left-radius: 14px;
  border-top-right-radius: 20px;
  letter-spacing: 0.5px;
  z-index: 2;
}

.grey-badge {
  background: #424242;
  color: #ccc;
}

.card-title {
  font-size: 1rem;
  font-weight: 800;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.2;
  margin-bottom: 2px;
}

.card-desc {
  font-size: 0.8rem;
  color: #aaa;
  line-height: 1.2;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* --- NEW STYLES FOR OFFERS VIEW --- */
.location-toggle {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.active-toggle {
  background-color: white !important;
  color: black !important;
  font-weight: 800;
}

.pricing-scroll-container {
  overflow-x: auto;

  padding-top: 15px;

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.pricing-card {
  background-color: #1e1e1e !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 16px !important;
  position: relative;
  overflow: visible;
}

.popular-card {
  border: 2px solid $wcf-green !important;
  box-shadow: 0 0 15px rgba($wcf-green, 0.2);
}

.popular-badge {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: $wcf-green;
  color: white;
  font-size: 0.6rem;
  font-weight: 900;
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
  z-index: 2;
}

.outlined-btn {
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* Simple fade transition */
.view-transition {
  animation: fadeIn 0.3s ease-in-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
